var _linearGradient, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 27,
    viewBox: "0 0 27 27",
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.529053,
    x2: 26.553,
    y1: 13.2464,
    y2: 13.2464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 27,
    maskUnits: "userSpaceOnUse",
    width: 27,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.529053 5.23438c0-2.76142 2.238577-5.000005 4.999997-5.000005h16.02395c2.7614 0 5 2.238575 5 5.000005v16.02392c0 2.7615-2.2386 5-5 5h-16.02394c-2.76143 0-5.000007-2.2385-5.000007-5z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m26.553 5.23438c0-2.76142-2.2386-5.000005-5-5.000005h-16.02394c-2.76143 0-5.000007 2.238575-5.000007 5.000005v16.02392c0 2.7615 2.238577 5 4.999997 5h16.02395c2.7614 0 5-2.2385 5-5zm-9.3144 11.46012c-1.4218 1.4218-3.6443 1.813-5.2105.552-.9163-.7376-1.7515-1.5713-2.48929-2.4861-1.26308-1.566-.86857-3.789.55409-5.21162.3036-.30361.3903-.7265.271-1.10602-.4113-1.24908-.61997-2.55598-.61803-3.87106 0-.59638-.48795-1.08433-1.08433-1.08433h-3.79516c-.59638 0-1.08433.48795-1.08433 1.08433 0 10.1819 8.25175 18.4336 18.43365 18.4336.5964 0 1.0843-.4879 1.0843-1.0843v-3.7843c0-.5964-.4879-1.0843-1.0843-1.0843-1.3446 0-2.6566-.2169-3.8711-.6181-.3795-.1301-.8132-.0325-1.106.2602z",
    fill: "url(#a)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.74955c81363c169e8ee7537d9b029f3e.svg";
export { ForwardRef as ReactComponent };